import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useT } from "talkr";
import { Button, Fab, IconButton, Link } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Section from "./Section";
import discoball from "./assets/discoball.gif";
import { useRef } from "react";
// import json from i18n/en.json
import en from "./i18n/en.json";
import plan from "./assets/plan.png";
import playerbackground from "./assets/playerbackground.png";
import FAQAccordion from "./Accordion";
import { BodyTypography } from "./typography/Typography";
import PlaceIcon from "@mui/icons-material/Place";
import ReactPlayer from "react-player";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
//@ts-ignore
import Flag from "react-world-flags";
import Markdown from "react-markdown";
import ColoredSVG from "./Colorpalette";
import { myColors } from "./theme";
import CustomizedTimeline from "./Timeline";

export default function App() {
  const { T, setLocale } = useT();
  const [playerZIndex, setPlayerZIndex] = React.useState(200);
  const [playerPlaying, setPlayerPlaying] = React.useState(true);
  const [colorPalette, setColorPalette] = React.useState<string[]>(
    []
  );

  const generateDressCodePalette = () => {
    // take these colour myColors.dressCodepalette and generate a palette of 18 colors in random order
    const colors = myColors.dressCodepalette;
    const palette = Array.from({ length: 13 }, (_, i) => colors[i % colors.length]);
    return palette.sort(() => Math.random() - 0.5); // Shuffle the array
  };

  React.useEffect(() => {
    const palette = generateDressCodePalette();
    setColorPalette(palette);
  }, []);


  const updatePalette = () => {
    const palette = generateDressCodePalette();
    setColorPalette(palette);
  };
  
  
  // every 2s change the colorPalette
  // Update colorPalette every 2s and on spacebar press
  React.useEffect(() => {
    
    const interval = setInterval(updatePalette, 2000);
    
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.code === "Space") {
        clearInterval(interval);
        updatePalette();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      clearInterval(interval);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);


  type Section = {
    title: string;
    innerRef: React.RefObject<HTMLElement>; // ref: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>
    color: string;
    backgroundColor: string;
  };

  const sections: { [key: string]: Section } = {
    details: {
      title: T("details"),
      color: "secondary.main",
      backgroundColor: "secondary.light",
      innerRef: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>,
    },
    program: {
      title: T("program"),
      color: "primary.contrastText",
      backgroundColor: "background.default",
      innerRef: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>,
    },
    location: {
      title: T("location.title"),
      color: "secondary.main",
      backgroundColor: "secondary.light",
      innerRef: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>,
    },
    dressCode: {
      title: T("dressCode"),
      color: "primary.contrastText",
      backgroundColor: "background.default",
      innerRef: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>,
    },
    questionsAndAnswers: {
      title: T("questionsAndAnswersTitle"),
      color: "secondary.main",
      backgroundColor: "secondary.light",
      innerRef: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>,
    },

    // accomondation: { title: T("accomondation"), ref: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>, color: "primary.contrastText", backgroundColor: "background.default" },
    // gifts: { title: T("gifts"), ref: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>, color: "primary.contrastText", backgroundColor: "secondary.light" },
    // contact: { title: T("contact"), ref: useRef<HTMLElement>(null) as React.RefObject<HTMLElement>, color: "primary.contrastText", backgroundColor: "background.default" },
  };

  const NavBarButtons = () => {
    return (
      <>
        {Object.keys(sections).map((section) => (
          <Button
            key={section}
            // variant="outlined"
            sx={{
              p: 1,
              textAlign: "center",
              margin: 1,
              whiteSpace: "nowrap",
              minWidth: "max-content",
            }}
            onClick={() =>
              sections[section].innerRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {sections[section].title}
          </Button>
        ))}
      </>
    );
  };

  const flagButtons = () => {
    return (
      <>
        <IconButton
          aria-label="delete"
          sx={{
            p: 1,
            textAlign: "center",
            margin: 1,
            color: "primary.contrastText",
            whiteSpace: "nowrap",
            minWidth: "max-content",
          }}
          onClick={() => {
            setLocale("sk");
          }}
        >
          <Flag code="sk" width={32} />
        </IconButton>
        <IconButton
          sx={{
            p: 1,
            textAlign: "center",
            margin: 1,
            color: "primary.contrastText",
            whiteSpace: "nowrap",
            minWidth: "max-content",
          }}
          onClick={() => {
            setLocale("en");
          }}
        >
          <Flag code="GB" width={40} />
        </IconButton>
        <IconButton
          sx={{
            p: 1,
            textAlign: "center",
            margin: 1,
            color: "primary.contrastText",
            whiteSpace: "nowrap",
            minWidth: "max-content",
          }}
          onClick={() => {
            setLocale("tw");
          }}
        >
          <Flag code="TW" width={35} />
        </IconButton>
        <IconButton
          sx={{
            p: 1,
            textAlign: "center",
            margin: 1,
            color: "primary.contrastText",
            whiteSpace: "nowrap",
            minWidth: "max-content",
          }}
          onClick={() => {
            setLocale("ua");
          }}
        >
          <Flag code="UA" width={35} />
        </IconButton>
        <IconButton
          sx={{
            p: 1,
            textAlign: "center",
            margin: 1,
            color: "primary.contrastText",
            whiteSpace: "nowrap",
            minWidth: "max-content",
          }}
          onClick={() => {
            setLocale("de");
          }}
        >
          <Flag code="DE" width={35} />
        </IconButton>
      </>
    );
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <FavoriteIcon sx={{fontSize: "100px", color: "red"}} /> */}

        {playerZIndex === 100 && (
          <IconButton
            aria-label="player"
            sx={{
              position: "absolute",
              top: window.innerWidth < 768 ? "12vh" : "15vh",
              zIndex: 300,
            }}
            onClick={() => setPlayerPlaying(!playerPlaying)}
          >
            {playerPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
        )}

        <ReactPlayer
          url="https://soundcloud.com/leobrownmusic/trio-ternura-a-gira-leo-brown-edit"
          muted={true}
          light={
            <img
              src={playerbackground}
              alt="Thumbnail"
              style={{ opacity: 0, width: 100 }}
            />
          }
          height={"1vh"}
          width={"1vh"}
          playing={playerPlaying}
          style={{
            margin: "10px",
            position: "absolute",
            top: window.innerWidth < 768 ? "12vh" : "15vh",
            zIndex: playerZIndex,
            backgroundColor: "transparent",
          }}
          controls={false}
          config={{
            soundcloud: {
              options: {
                auto_play: true,
                show_artwork: false,
                show_playcount: false,
                show_user: false,
                download: false,
                sharing: false,
                buying: false,
              },
            },
          }}
          onClickPreview={() => {
            setPlayerZIndex(100);
          }}
        />
        <img
          src={discoball}
          style={{
            zIndex: 100,
            position: "absolute",
            // height: '30vh', // 30% of the viewport height
            height: window.innerWidth < 768 ? "25vh" : "30vh", // smaller on mobile
            top: 0,
          }}
        />
        <Typography
          variant="h1"
          fontFamily={"spinwerad"}
          sx={{
            mb: 2,
            textAlign: "center",
            fontSize: { xs: 60, sm: 100, xl: 140 },
            color: "primary.contrastText",
            marginLeft: { xs: -14, sm: -20 },
            marginTop: { xs: 15, sm: 25 }, // Adjust margin for mobile (xs) and larger screens
          }}
        >
          Viktória
        </Typography>
        <Typography
          variant="h1"
          fontFamily={"spinwerad"}
          sx={{
            mb: 2,
            textAlign: "center",
            fontSize: { xs: 60, sm: 100, xl: 140 },
            color: "primary.contrastText",
            marginTop: { xs: -7, sm: -9, xl: -12 }, // Adjust margin for mobile (xs) and larger screens
            marginBottom: { xs: -6, sm: -9, xl: -12 }, // Adjust margin for mobile (xs) and larger screens
            opacity: 0.7,
          }}
        >
          &
        </Typography>
        <Typography
          variant="h1"
          fontFamily={"spinwerad"}
          sx={{
            mb: 2,
            textAlign: "center",
            fontSize: { xs: 60, sm: 100, xl: 140 },
            color: "primary.contrastText",
            marginRight: { xs: -14, sm: -20 },
          }}
        >
          Richard
        </Typography>
        <Link
          variant="h1"
          letterSpacing={15}
          fontFamily={"spinwerad"}
          href="https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20250823T123000Z%2F20250824T040000Z&location=St.%20Sebastian%20Catedral&text=Wedding%20Richard%20%26%20Viki"
          underline="none"
          sx={{
            mb: 1,
            fontSize: { xs: 60, sm: 70 },
            textAlign: "center",
            color: "primary.contrastText",
          }}
        >
          23.8.2025
        </Link>

        <Typography
          variant="h5"
          fontFamily={"spinwerad"}
          sx={{ textAlign: "center", color: "primary.contrastText" }}
        >
          {T("catedral_name")}
        </Typography>

        {/* <AppBar position="sticky" sx={{backgroundColor: "background.default", boxShadow: "none", heigth:"20vh",}}> */}
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            // marginTop: { xs: 5, sm: 1, md: 1, lg: 1 },
          }}
        >
          {NavBarButtons()}
        </Box>
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {flagButtons()}
        </Box>

        {/* </AppBar> */}

        {/* <Box
            sx={{
              backgroundImage: `url(${berghein})`,
              backgroundSize: "200%", // Zoom the image
              backgroundPosition: "center -180px",
              backgroundRepeat: "no-repeat",
              width: "100%",
              height: "80%",
            }}
          /> */}
      </Box>

      

      <Section {...sections.details}>
        <Typography
          variant="body1"
          component="h1"
          sx={{ mb: 2, textAlign: "left", color: "secondary.main" }}
        >
          {T("intro_description")}
        </Typography>
      </Section>

      <Section {...sections.program}>
        <Grid container spacing={10}>
          <Grid size={{ xs: 12, md: 12 }}>
          <CustomizedTimeline />
          </Grid>
        </Grid>
      </Section>

      <Section {...sections.location}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Typography
              variant="body1"
              component="h1"
              sx={{ mb: 2, textAlign: "left", color: "secondary.main" }}
            >
              {T("location.description")}
            </Typography>
          </Grid>
          
          <Grid size={{ xs: 12, md: 6 }}>
            {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1009.8801182998511!2d17.13177604635814!3d48.183699379457195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476c8e99fd8c067d%3A0xee0e888711184975!2sNov%C3%A1%20Cvernovka!5e1!3m2!1ssk!2scz!4v1742257683150!5m2!1ssk!2scz"
                width="100%"
                height="150"
                style={{ border: 0 }}
                loading="lazy"
              />
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2434.4717404509197!2d17.140439075960458!3d48.1957294471115!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476c8e87e3e56437%3A0xa12aac3f064781c2!2sKatedr%C3%A1la%20sv.%20%C5%A0ebasti%C3%A1na%20(Ordinari%C3%A1t%20OS%20SR)!5e1!3m2!1ssk!2scz!4v1742515825282!5m2!1ssk!2scz"
                width="100%"
                height="150"
                style={{ border: 0 }}
                loading="lazy"
              /> */}
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <img src={plan} style={{ zIndex: 100, width: "100%" }} />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <BodyTypography text={`A - ${T(`plan_points.A`)}`} />
            <BodyTypography text={`B - ${T(`plan_points.B`)}`} />
            <BodyTypography text={`C - ${T(`plan_points.C`)}`} />
            <BodyTypography text={`D - ${T(`plan_points.D`)}`} />
            <BodyTypography text={`E - ${T(`plan_points.E`)}`} />
            <BodyTypography text={`F - ${T(`plan_points.F`)}`} />

            <BodyTypography
              text={T(`location.to_navigation`)}
              sx={{ marginTop: 5 }}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: "left",
                gap: 2,
                whiteSpace: "nowrap",
                paddingTop: 1,
              }}
            >
              <Fab
                variant="extended"
                size="small"
                color="secondary"
                href="https://maps.app.goo.gl/7wUBNoUAnu91aKKS6"
              >
                <PlaceIcon />
                {T(`catedral_name`)}
              </Fab>
              <Fab
                variant="extended"
                size="small"
                color="secondary"
                href="https://maps.app.goo.gl/hnYVaG8aWBGmsdHv5"
              >
                <PlaceIcon />
                {T(`nova_cvernovka`)}
              </Fab>
            </Box>
          </Grid>
        </Grid>
      </Section>
      <Section {...sections.dressCode}>
        <Typography
          variant="body1"
          component="h1"
          sx={{ mb: 2, textAlign: "left", color: "primary.contrastText" }}
        >
          <Markdown>{T("dressCodeDescription")}</Markdown>
        </Typography>
        <ColoredSVG colors={colorPalette} onClick={updatePalette} />
      </Section>
      <Section {...sections.questionsAndAnswers}>
        <FAQAccordion />
      </Section>
      <Section {...sections.venue}>
        <Box
          sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        width: "100%",
        py: 1,
          }}
        >
          <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
          maxWidth: 250,
        }}
          >
        <a href="https://www.msba.sk/" target="_blank" rel="noopener noreferrer">
          <img
            src={require("./assets/makerspace.png")}
            alt="Makerspace"
            style={{ width: "100%", height: "auto", borderRadius: 8 }}
          />
        </a>
          </Box>
          <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
          maxWidth: 250,
        }}
          >
        <a href="https://novacvernovka.eu/" target="_blank" rel="noopener noreferrer">
          <img
            src={require("./assets/nc.png")}
            alt="NC"
            style={{ width: "100%", height: "auto", borderRadius: 8 }}
          />
        </a>
          </Box>
          <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
          maxWidth: 250,
        }}
          >
        <a href="https://www.pressink.sk/" target="_blank" rel="noopener noreferrer">
          <img
            src={require("./assets/pressink.png")}
            alt="Pressink"
            style={{ width: "100%", height: "auto", borderRadius: 8 }}
          />
        </a>
          </Box>
        </Box>
      </Section>

      {/* </Box> */}
    </>
  );
}
